<div class="mcm-metric-detail-item">
  <span class="mcm-metric-detail-item__text"> {{ item().text | translate }} </span>
  <span class="mcm-metric-detail-item__value">
    {{
      item()?.leftValue != null
        ? (item()?.leftValue | number: '' : lang()) + ((item()?.leftUnit | translate) || '')
        : '-'
    }}
  </span>
</div>
